<template>
  <div>
    <v-row align-center justify-center fill-height class="my-3">
      
      <v-col cols="2" md="2" lg="2" class="pa-2">
        <!-- <v-img src="path/to/your/image.jpg" alt="Descripción de la imagen"></v-img> -->
      </v-col>

      <v-col cols="8" md="8" lg="8" class="pa-2">
        <v-card>
          <v-card-title class="text-h5">
            Pantalla de Ingreso al Sistema
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">

                  <!-- <v-icon
        right
        dark
      >
        mdi-google
      </v-icon> -->




                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                      v-model="usuario.name"
                      label="Usuario Nombre"
                      disabled
                      v-if="false"
                      data-cy="name-input"
                    ></v-text-field>


                        <v-text-field
           v-model="usuario.email"
           label="Correo"
           :counter="3"
           :rules="emailRules"
           required
         ></v-text-field>
   

                    <v-text-field
                      v-model="usuario.password"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min]"
                      :type="showPass ? 'text' : 'password'"
                      name="input-pass"
                      label="Contraseña"
                      hint="Minimo 5 caracteres"
                      counter
                      @click:append="showPass = !showPass"
                      data-cy="pass-input"
                    ></v-text-field>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>

               <v-row >
         <v-col
          cols="12" sm="12" lg="6" class="d-flex justify-end">

            <v-btn class="mr-2"  outlined color="red darken-1"  text  @click="cancelar">
               <v-icon>
       mdi-cancel
      </v-icon> 
              Cancelar
            </v-btn>

            
            <v-btn class="mr-2" outlined color="blue darken-4" 
            text @click="ingresar"
            data-cy="submit"
            >
            <v-icon>
       mdi-email-outline
      </v-icon> 
              Ingresar
            </v-btn>

          </v-col>

<v-col
          cols="12" sm="12" lg="6" class="d-flex justify-end">
             <v-btn class="mr-2" outlined color="blue darken-4" 
            text
             @click="loginWithGoogle"
            data-cy="submit"
            >
            <img src="@/assets/img/svg/google-icon.svg" alt="Google Icon" width="20" height="20" class="mr-1">
          
              LOGIN WITH GOOGLE
      
            </v-btn> 

</v-col>
 

  <v-col cols="12" sm="12" lg="12" class="d-flex justify-end">


          <!-- <v-btn color="blue darken-4" 
            text @click="abrirModal">
           
             ¿Olvidó su contraseña?
            </v-btn> -->

            <EnviarCorreoDialog></EnviarCorreoDialog>
        

  </v-col>

               </v-row>






  <!--  INICIO DE SESION POR GOOGLE DIALOG NO UTILIZADO
    
    <GoogleDialog    :usuarioData="usuario"   @usuarioEdit="recibirUsuario"></GoogleDialog>  -->

              <!-- <v-btn color="green darken-1" 
            text
             @click="loginWithGoogle2"
            data-cy="submit"
            >
              LOGIN WITH GOOGLE
              <v-icon
        right
        dark
      >
        mdi-google
      </v-icon>
            </v-btn>   -->


            <!-- <v-btn color="green darken-1" 
            text @click="loginWithFacebook"
            data-cy="submit"
            >
              LOGIN WITH FACEBOOK
              <v-icon
        right
        dark
      >
        mdi-facebook
      </v-icon>
            </v-btn> -->

      
              <!-- <router-link :to="{ path: 'register'}">Registrarse</router-link> -->
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import EnviarCorreoDialog from '@/components/auto_register/gestion/EnviarCorreoDialog';
import loginService from "@/services/loginService.js";

import GoogleDialog from "@/components/usuario/GoogleDialog";

import router from "@/router/index";



import {http} from '@/services/config';

export default {
  name: "Usuario",
  // props:['enviarDependencia'],
  components: {

    GoogleDialog,
    EnviarCorreoDialog
  },
  data: () => ({
    valid: true,
    token: "",
    messages: undefined,
    showPass: false,
    rules: {
      required: (value) => !!value || "Campo Requerido",
      min: (v) => v.length >= 5 || "Minimo 5 caracteres",
      emailMatch: () => `Email y contraseña no coinciden`,
    },

    usuarios: [],
    usuario: {
      name: "",
      email:"",
      password: ""
    },

    descripcionRules: [
      (v) => !!v || "Campo es requerido",
      (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
    ],

    emailRules: [
      (v) => !!v || "Correo es requerido",
      (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
    ],
  }),
  mounted() {
 

    
  },







  methods: {

    async recaptcha() {
  try {
    
    await this.$recaptchaLoaded();

    const token = await this.$recaptcha('login');

    
    return token;
  } catch (error) {
    console.error('Error al ejecutar reCAPTCHA:', error);
    throw error; 
  }
}
,

    recibirUsuario:function(usuario2){

      console.log('En elemento padre Opcion despues de editar:'+usuario2);
        console.log(usuario2);

      //  this.listarOpcions(this.$route.params.identificador);
 
    },
    async loginWithGoogle2() {
      try {
        const response = await http.get('api/login/google', {
          // datos de la petición, si es necesario
        });
        console.log('Login exitoso:', response.data);
      } catch (error) {
        console.error('Error en el login:', error);
      }
    }
  
    ,
            loginWithGoogle() {

             
               /* loginService.autenticarGoogle().then((resp) => {

                    console.log("Autenticación por Google");
                  console.log(resp.data);
                  

                })*/
            
                 // window.location.href = 'http://127.0.0.1:8000/api/login/google';

                //  this.$router.push(`/api/login/google`);

                const url = this.$router.resolve({ path: '/api/login/google' }).href;
              window.location.href = url;


                  //window.open('http://127.0.0.1:8000/api/login/google', '_blank');
            },

            loginWithFacebook() {
                window.location.href = 'http://127.0.0.1:8000/api/login/facebook'
            },

    async ingresar() {



      try {
    const token = await this.recaptcha(); // Espera hasta que recaptcha() termine
  //  console.log('Token obtenido:', token);
          this.usuario.recaptcha=token;

        } catch (error) {
    console.error('Error en reCAPTCHA:', error);
  }
    
  
      if (this.$refs.form.validate()) {
       // console.log(this.usuario);
        loginService.autenticar(this.usuario).then((response) => {
          //  console.log("imprimir prueba")
         
          //  console.log(response.data.data.identificador);
       
        // console.log("Prueba token");
         //  console.log(response.data.data.token);
         this.token = response.data.data.token;
          localStorage.setItem("token", this.token);
          this.$store.commit('setIdentificador', response.data.data.identificador);
          this.$store.commit('setLinkPhoto', response.data.data.linkPhoto || '');
          this.$store.commit('setRoles', response.data.data.roles || []);
          this.$store.commit('setLogueado', true);

        //  this.usuario.password='';
          //this.$store.commit('setUsuario', this.usuario);
          router.push("perfil/"+response.data.data.identificador+"/add"); 

          console.log("Envio datos para login");

          this.limpiar();
          alert("Ingreso correcto al sistema!!");
        });
      }


    

    },
    eliminarToken() {
      localStorage.removeItem("token");
      alert("Cierre de Sesión exitoso");
      router.push("login");
    },
    cancelar() {
      this.limpiar();
   
    },
    limpiar() {
      this.usuario = {
        name: "",
        password: ""
      };
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
  computed: {
    
  },
};
</script>

<style>
.google-font {
  font-family: 'Google Sans', sans-serif;
}
</style>
